import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSortArrows = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M2.4 7.07998L6.5 2.97998L10.61 7.07998C10.81 7.27998 10.81 7.58998 10.61 7.78998C10.52 7.88998 10.38 7.93998 10.26 7.93998C10.14 7.93998 10.01 7.88998 9.91 7.78998L7.01 4.88998V20.5C7.01 20.78 6.79 21 6.51 21C6.23 21 6.01 20.78 6.01 20.5V4.88998L3.11 7.78998C2.91 7.98998 2.6 7.98998 2.4 7.78998C2.2 7.58998 2.2 7.27998 2.4 7.07998Z' />
    <path d='M20.89 16.21C21.09 16.01 21.4 16.01 21.6 16.21H21.58C21.78 16.41 21.78 16.72 21.58 16.92L17.48 21.02L13.38 16.92C13.18 16.72 13.18 16.41 13.38 16.21C13.58 16.01 13.89 16.01 14.09 16.21L16.99 19.11V3.49998C16.99 3.21998 17.21 2.99998 17.49 2.99998C17.77 2.99998 17.99 3.21998 17.99 3.49998V19.11L20.89 16.21Z' />
  </svg>
);
export default SvgSortArrows;
